export enum TextFieldList {
  STRING = 'string',
  PHONE = 'phone',
  EMAIL = 'email',
  LINK = 'link',
  ADDRESS = 'address',
}

export enum FileFieldList {
  LINK_FILE = 'link_file',
}

export enum LogicFieldList {
  BOOLEAN = 'boolean',
}

export enum NumberFieldList {
  NUMBER = 'number',
  PERCENT = 'percent',
}

export enum DateFieldList {
  DATE = 'date',
  MONTH = 'month',
  YEAR = 'year',
  RANGE = 'range',
  PERIOD = 'period',
}

export enum ListFieldList {
  LIST = 'list',
  LIST_TYPES = 'list_types',
}

export enum InteratorFieldList {
  SIMPLE = 'interator_simple',
}

export enum OptionalFieldList {
  COMPUTED = 'computed',
}

export enum ReferenceFieldList {
  OBJECT_LINK = 'object_link',
}

export const TypeFieldList = [
  {
    name: 'Тестовые поля',
    children: [
      {
        key: TextFieldList.STRING,
        name: 'Текст',
      },
      {
        key: TextFieldList.PHONE,
        name: 'Номер телефона',
      },
      {
        key: TextFieldList.EMAIL,
        name: 'Эл. почта',
      },
      {
        key: TextFieldList.LINK,
        name: 'Сетевой адрес (ссылка)',
      },
      {
        key: TextFieldList.ADDRESS,
        name: 'Адрес',
      },
      {
        key: FileFieldList.LINK_FILE,
        name: 'Сетевой адрес (файл)',
      },
    ],
  },
  {
    name: 'Логические поля',
    children: [
      {
        key: LogicFieldList.BOOLEAN,
        name: 'Булев',
      },
    ],
  },
  {
    name: 'Числовые поля',
    children: [
      {
        key: NumberFieldList.NUMBER,
        name: 'Число',
      },
      {
        key: NumberFieldList.PERCENT,
        name: 'Процент',
      },
    ],
  },
  {
    name: 'Поля даты',
    children: [
      {
        key: DateFieldList.DATE,
        name: 'Одиночная дата',
      },
      {
        key: DateFieldList.MONTH,
        name: 'Месяц',
      },
      {
        key: DateFieldList.YEAR,
        name: 'Год',
      },
      {
        key: DateFieldList.RANGE,
        name: 'Промежуток',
      },
      {
        key: DateFieldList.PERIOD,
        name: 'Период',
      },
    ],
  },
  {
    name: 'Поля списки',
    children: [
      {
        key: ListFieldList.LIST,
        name: 'Список',
      },
      {
        key: ListFieldList.LIST_TYPES,
        name: 'Справочник',
      },
    ],
  },
  {
    name: 'Интератор',
    children: [
      {
        key: InteratorFieldList.SIMPLE,
        name: 'Стандартный',
      },
    ],
  },
  {
    name: 'Ссылочные поля',
    children: [
      {
        key: ReferenceFieldList.OBJECT_LINK,
        name: 'Ссылка на объект',
      },
    ],
  },
  {
    name: 'Дополнительные',
    children: [
      {
        key: OptionalFieldList.COMPUTED,
        name: 'Вычисляемое поле',
      },
    ],
  },
]

export const TriggerUpdateList = [
  { value: 'CREATED', title: 'При создании' },
  { value: 'UPDATED', title: 'При обновлении' },
  { value: 'ALL', title: 'Всегда' },
]

export const PeriodUpdateList = [
  { value: 'DAILY', title: 'Ежедневно' },
  { value: 'WEEKLY', title: 'Еженедельно' },
  { value: 'MONTHLY', title: 'Ежемесячно' },
  { value: 'YEARLY', title: 'Ежегодно' },
]

export const ComputedTypeList = [
  {
    value: 'MAX',
    title: 'Максимальное значение',
    accept_fields: [
      ...Object.values(NumberFieldList),
      ...Object.values(TextFieldList),
      ...Object.values(LogicFieldList),
      ...Object.values(DateFieldList),
      ...Object.values(ListFieldList),
      ...Object.values(InteratorFieldList),
    ],
  },
  {
    value: 'MIN',
    title: 'Минимальное значение',
    accept_fields: [
      ...Object.values(NumberFieldList),
      ...Object.values(TextFieldList),
      ...Object.values(LogicFieldList),
      ...Object.values(DateFieldList),
      ...Object.values(ListFieldList),
      ...Object.values(InteratorFieldList),
    ],
  },
  { value: 'SUM', title: 'Сумма', accept_fields: [...Object.values(NumberFieldList)] },
  {
    value: 'AVG',
    title: 'Среднее значение',
    accept_fields: [...Object.values(NumberFieldList)],
    ...Object.values(DateFieldList),
  },
  {
    value: 'UNIQ',
    title: 'Количество (уникальные значения)',
    accept_fields: [
      ...Object.values(NumberFieldList),
      ...Object.values(TextFieldList),
      ...Object.values(DateFieldList),
      ...Object.values(ListFieldList),
      ...Object.values(InteratorFieldList),
    ],
  },
]

export const ComputedConditionList = [
  {
    value: null,
    title: 'Без условий',
    accept_fields: [
      ...Object.values(TextFieldList),
      ...Object.values(NumberFieldList),
      ...Object.values(LogicFieldList),
      ...Object.values(DateFieldList),
      ...Object.values(InteratorFieldList),
      ...Object.values(OptionalFieldList),
      ...Object.values(FileFieldList),
      ...Object.values(ListFieldList),
    ],
  },
  {
    value: 'MORE',
    title: 'Больше или равно',
    accept_fields: [
      ...Object.values(TextFieldList),
      ...Object.values(NumberFieldList),
      ...Object.values(DateFieldList),
      ...Object.values(InteratorFieldList),
      ...Object.values(OptionalFieldList),
    ],
  },
  {
    value: 'LESS',
    title: 'Меньше или равно',
    accept_fields: [
      ...Object.values(TextFieldList),
      ...Object.values(NumberFieldList),
      ...Object.values(DateFieldList),
      ...Object.values(InteratorFieldList),
      ...Object.values(OptionalFieldList),
    ],
  },
  {
    value: 'EQUAL',
    title: 'Равно',
    accept_fields: [
      ...Object.values(TextFieldList),
      ...Object.values(NumberFieldList),
      ...Object.values(LogicFieldList),
      ...Object.values(DateFieldList),
      ...Object.values(InteratorFieldList),
      ...Object.values(OptionalFieldList),
    ],
  },
  {
    value: 'INCLUDE',
    title: 'Содержит строку',
    accept_fields: [...Object.values(TextFieldList)],
  },
  {
    value: 'RANGE',
    title: 'В диапазоне',
    accept_fields: [
      ...Object.values(NumberFieldList),
      ...Object.values(DateFieldList),
      ...Object.values(InteratorFieldList),
      ...Object.values(OptionalFieldList),
    ],
  },
  {
    value: 'IN_LIST',
    title: 'Из списка',
    accept_fields: [...Object.values(ListFieldList)],
  },
]
